import { AfterViewInit, Component, OnInit, ChangeDetectorRef, OnDestroy, HostListener, Input } from '@angular/core';

import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';

import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LocalizationService } from '@services/localization.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { UserHelper } from '@helpers/user.helper';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Location } from '@angular/common';

import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { Validators } from '@angular/forms';
import { environment } from '@environments/environment';

@Component({
  selector: 'sports-component',
  templateUrl: '../sharedTemplates/sports.component.html',
})
export class SportsComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    public _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private cdRef: ChangeDetectorRef,
    private _SignalRService: SignalrServiceLegacy,
    private _webWorkerService: WebWorkerService,
    private _location: Location
  ) {
    if (this._DataHelper.LeagueData !== undefined) {
      this.sportName = this._DataHelper.LeagueData[0].SportName;
      this.countryName = this._DataHelper.LeagueData[0].CategoryName;
      this.leagueName = this._DataHelper.LeagueData[0].TournamentName;
      this.sportId = this._DataHelper.LeagueData[0].SportId;
    }

    const urlPopular = this._Router.url.indexOf('/popular');
    const urlHighlights = this._Router.url.indexOf('/highlights');
    const urlLastminute = this._Router.url.indexOf('/lastminute');
    const urlEvents = this._Router.url.indexOf('/events');
    this.urlFavs = this._Router.url.indexOf('/fav');

    if (urlPopular > -1) {
      this.urlIsPopular = true;
      this.liveIsActive = false;
    }
    if (this.urlFavs > -1) {
      this.openFavPreMatches();
    }

    if (urlHighlights > -1 || urlLastminute > -1 || urlEvents > -1) {
      this.liveIsActive = false;
    }

    if (this._Router.url.indexOf('/search') > -1) {
      this._UiHelper.setSportInputStatus(true);
    } else {
      this._UiHelper.setSportInputStatus(false);
    }

    // BURAYI KONTROL ET

    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.searchDataListener.subscribe(x => {
        x.length > 0 ? this.changeSearch(true) : this.changeSearch(false);
        const a = this.getFavorableStates(x);
        this.preMatchList = a;
        this.preMatchobservable.next(this.preMatchList);
      })
    );

    let isBelowGivenWidth = this._UiHelper.windowsWidth < 990;
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w >= 990) {
        if (isBelowGivenWidth) {
          this.tournamentSelectionState(1);
        }
      } else {
        isBelowGivenWidth = true;
      }
    });

    this.searchEventSubject

      .pipe(debounceTime(500))
      .pipe(distinctUntilChanged())
      .subscribe(x => {
        this.flagSearch = true;
        this.getSearchB3000(x);
        this.changeSearch(false);
      });
  }
  searchInput = '';

  searchInputObj = {
    group: 1,
    fname: 'username',
    type: 'input_text_username',
    FType: 'input_text',
    value: '',
    placeholder: 'Search',
    hint: '',
    errText: '',
    isActive: true,
    validators: [Validators.minLength(3)],
    key: 'fieldusername',
  };

  urlFavs = -1;
  tournamentFavourited = false;
  translator = new TranslatePipe(this._LocalizationService);

  searchEventSubject = new Subject();

  sportName = '';
  countryName = '';
  leagueName = '';
  sportId = 1;

  preMatchList = [];

  homeSliderData = [];
  contentHeight;
  othersHeight;
  preMatchobservable = new BehaviorSubject<any>([]);
  favPreMatchobservable = new BehaviorSubject<any>([]);
  LeagueData: Array<any>;
  _selectedOdds: OddModel[] = [];
  oddMarketingValue = [0]; // WETTARENA

  oddMarketingB3000Value = [0, 4, 3, 5]; // B3000

  _catId = '0';

  isResult = false;

  panLeft = '0';

  // Live Parts
  liveMatchList = [];
  oldLiveMatchList = [];
  cardList = [];
  __ResultLiveData;
  fullmatch: Observable<any[]>;
  isInitialized = false;
  __ResultLiveFavsData;

  urlIsPopular = false;
  liveIsActive = true;

  private subscriptionsToStopOnDestroy: Subscription[] = [];

  // B3000

  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;

  // [0,2,3];
  oddComboList: Array<OddComboModel> = [
    {
      OddId: 0,
      OddNameLong: 'tipp_long',
      OddName: 'tipp',
      OddTitles: ['1', 'X', '2'],
    },
    {
      OddId: 1,
      OddNameLong: 'handicap',
      OddName: 'hc',
      OddTitles: ['', '1', 'X', '2'],
    },
    {
      OddId: 2,
      OddNameLong: 'O/U_long',
      OddName: 'O/U',
      OddTitles: ['', '+', '-'],
    },
    {
      OddId: 3,
      OddNameLong: 'DoppelteChance',
      OddName: 'DC',
      OddTitles: ['1X', '12', 'X2'],
    },
    {
      OddId: 4,
      OddNameLong: 'Treffenbeide?',
      OddName: 'TF?',
      OddTitles: ['Y', 'N'],
    },
    {
      OddId: 5,
      OddNameLong: 'NextGoal',
      OddName: 'NT',
      OddTitles: ['1', 'X', '2'],
    },
    {
      OddId: 6,
      OddNameLong: 'HTFirstHalf',
      OddName: 'TIPP 1.HZ',
      OddTitles: ['1', 'X', '2'],
    },
    {
      OddId: 7,
      OddNameLong: 'Ü/U 1.HZ_long',
      OddName: 'Ü/U 1.HZ',
      OddTitles: ['', '+', '-'],
    },
  ];

  combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);
  combo2SelectedOdd = this.oddComboList.find(combo => combo.OddId == 4);
  combo3SelectedOdd = this.oddComboList.find(combo => combo.OddId == 3);
  combo4SelectedOdd = this.oddComboList.find(combo => combo.OddId == 5);

  basepreMatchList;
  currentActiveTimeFilter = 0;

  tournamentSelection = {
    page: 1,
    page1InsideSelection: 'total',
    isTournamentSelection: false,
    tournamentName: '',
    tournamentId: 0,
    data: {
      seasonName: '',
      year: '',
      seasonStandings: [],
      last6SummaryStats: [],
    },
  };
  tournamentSelectionB3000 = {
    page: 1,
    page1InsideSelection: 'total',
    isTournamentSelection: false,
    tournamentName: '',
    tournamentId: 0,
    tournamentBetradarId: 0,
    SportId: 0,
    CategoryId: 0,
    data: [],
  };
  resendMailButtonState = true;
  flagSearch = false;
  @HostListener('window:resize', ['$event'])
  onResize() {
    // used windopw-innerWidth
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  ngOnInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._ActivatedRoute.params.subscribe(p => {
        if (p['q'] == 0) {
          this.changeSearch(false, true);
        }

        if (p['q'] != undefined && p['q'] != null && this._DataHelper.searchData != undefined) {
          if (environment.IsBet3000) {
            this.getSearchB3000(p['q']);
          } else {
            this._ApiService.getSearch(p['q']).then(x => {
              this._DataHelper.setSearchData(x);
            });
          }
        }

        if (p['q'] != undefined && p['q'] != null && this._DataHelper.searchData == undefined) {
          this._DataHelper.setSearchDataViaUrl(p['q']);
        }
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._ActivatedRoute.queryParams.subscribe(p => {
        if (p['TimeRangeId'] != undefined && p['TimeRangeId'] != null) {
          this._DataHelper.leftMenuSportDayFilter = p['TimeRangeId'];
        }

        if (p['MenuId'] != undefined && p['MenuId'] != null) {
          this._catId = p['MenuId'];
        }
        this.getSelectedFixture();
      })
    );
    this.subscriptionsToStopOnDestroy.push(
      this._ActivatedRoute.params.subscribe(p => {
        if (p['MenuId'] != undefined && p['MenuId'] != null) {
          this._DataHelper.leftMenuSportDayFilter = p['TimeRangeId'];
        }

        if (p['TimeRangeId'] != undefined && p['TimeRangeId'] != null) {
          this._catId = p['MenuId'];
        }
        this.getSelectedFixture();
      })
    );
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('', null, false);
    this.heightsetter(this._UiHelper.windowsHeight);
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        this.heightsetter(x.h);
      })
    );

    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.contentHeightListener.subscribe(x => {
        this.othersHeight = x;
      })
    );

    // Daha önce seçilen oddları tekrar seçsin
    this.subscriptionsToStopOnDestroy.push(
      this._ApiService.selectedOddsEvent.subscribe(x => {
        this._selectedOdds = x as OddModel[];
      })
    );
    this._ApiService.getSelectedOdds();

    // B3000 de Mobil de çalışmıyor. Routing den dolayı. Desktop ta çalışıyor
    // Sports Filter Control
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.LeagueDataListener.subscribe(x => {
        // Filter değişince listeyi değiştir
        this.getFixture();
      })
    );

    // Favs kapandı
    // this.getFavs();

    // Live : If connection is not exists
    if (!this._SignalRService.connectionExists) {
      this.subscriptionsToStopOnDestroy.push(
        this._SignalRService.connectionEstablished.subscribe(x => {
          // //////console.log("canlı bağlandı detayda : ", x);
          this.connectHub();
        })
      );
    } else {
      this.connectHub();
    }
  }

  getSelectedFixture() {
    if (this._Router.url.indexOf('/popular') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-1');
    } else if (this._Router.url.indexOf('/highlights') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-2');
    } else if (this._Router.url.indexOf('/home') > -1) {
      this._DataHelper.LeagueData = undefined;
      // 11-05-2022 --  N2-316 daki maddeye göre getPopularFixture veya getFixture arasında tercih yap
      // this.getFixture();
      this.getPopularFixture('-2');
    } else if (this._Router.url.indexOf('/lastminute') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-3');
    } else if (this._Router.url.indexOf('/events') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-4');
    } else if (this._Router.url.indexOf('/allevents') > -1) {
      this._DataHelper.LeagueData = undefined;
      this.getPopularFixture('-15');
    } else if (this._Router.url.indexOf('/search') > -1) {
      //// console.log('YYES',this._Router.url.indexOf('/0'));
      if (this._Router.url.indexOf('/0') > -1) {
        this.changeSearch(false, true);
      }
    } else if (this._Router.url.indexOf('/league') > -1) {
      const selectedLeagueData = [];

      this.subscriptionsToStopOnDestroy.push(
        this._ActivatedRoute.queryParams.subscribe(p => {
          if (p['CatId'] != undefined && p['CatId'] != null) {
            const cbData = {
              TournamentName: '',
              TournamentId: p['TourId'],
              CategoryId: p['CatId'],
              CategoryName: '',
              SportId: 1,
              SportName: 'Soccer',
            };

            selectedLeagueData.push(cbData);
            this._DataHelper.leftMenuSportDayFilter = 300;
            this._DataHelper.setLeagueData(selectedLeagueData);
          }
        })
      );

      this.getPopularFixture('-4');
    } else {
      if (this.urlFavs < 0) {
        this.getFixture();
      }
    }
  }

  heightsetter(c) {
    this.contentHeight = c - this.othersHeight;
    this.contentHeight += 'px';
  }

  changeSearch(v, ui?) {
    this.isResult = v;
    ui ? this.getFixture() : null;
  }

  getFavorableStates(_x) {
    const a = this._UserHelper.favoriedMatches;
    return _x.map(y => {
      // //////console.log(a, y.BetradarMatchId);
      if (a == null) {
        return y;
      }
      if (a.includes(y.BetradarMatchId)) {
        y['favorableState'] = true;
        return y;
      } else {
        y['favorableState'] = false;
        return y;
      }
    });
  }

  getFixture() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService
      .getFixture()
      .then(x => {
        x = this.getFavorableStates(x);
        this.preMatchList = x;

        this.preMatchobservable.next(this.preMatchList);
        this.changeSearch(false);
        this._UiHelper.setLoadingDialog(false);

        const tournamentsArray = new Set(this.preMatchList.map(i => i.BetradarTournamentId));
        this.tournamentSelectionB3000.isTournamentSelection = tournamentsArray.size === 1;

        this.tournamentSelection.isTournamentSelection = tournamentsArray.size === 1;
        if (this.preMatchList && this.preMatchList.length > 0) {
          try {
            this.tournamentSelection.tournamentName = this.preMatchList[0].TournamentNameShort;
            this.tournamentSelection.tournamentId = this.preMatchList[0].BetradarTournamentId;

            this.tournamentSelectionB3000.SportId = this.preMatchList[0].SportId;
            this.tournamentSelectionB3000.tournamentId = this.preMatchList[0].TournamentId;
            this.tournamentSelectionB3000.tournamentBetradarId = this.preMatchList[0].BetradarTournamentId;
          } catch (e) {
            console.log('sports', e);
          }
        }

        if (this.tournamentSelectionB3000.isTournamentSelection) {
          // this.getTournamentStatistic();
          this.getTournamentStatisticB3000();
        }

        this.dataRebuild();

        this.cdRef.detectChanges();
        if (this._UiHelper.leftMenu) {
          this._UiHelper.setLeftMenu();
        }

        setTimeout(() => {
          this._UiHelper.ScrollToTop();
        }, 100);
      })
      .catch(err => console.log('sports', err));
  }

  getPopularFixture(_sId) {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService
      .getFixture(_sId, this._catId)
      .then(x => {
        this.preMatchList = x;
        this.preMatchobservable.next(this.preMatchList);
        this.changeSearch(false);

        if (this._UiHelper.leftMenu) {
          this._UiHelper.setLeftMenu();
        }

        this._UiHelper.setLoadingDialog(false);
      })
      .catch(err => console.log('sports', err));
  }

  getFavs() {
    this._ApiService.getSearch4Favs().then(x => {
      x = this.getFavorableStates(x);
      this.favPreMatchobservable.next(x);
      this.cdRef.detectChanges();
    });
  }

  favsChanged() {
    this.getFavs();

    this.preMatchList = this.getFavorableStates(this.preMatchList);
    this.preMatchobservable.next(this.preMatchList);
  }

  connectHub() {
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.liveDataListener.subscribe(y => {
        this.oldLiveMatchList = this.liveMatchList;
        this.liveMatchList = y;
        this.cdRef.detectChanges();
        this.dataRebuild();
      })
    );

    this.liveMatchList = this._DataHelper.liveData;
    this.oldLiveMatchList = this.liveMatchList;

    // Card
    this.cardList = this._DataHelper.cardData;
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.cardDataListener.subscribe(y => {
        this.cardList = y;
      })
    );
    // Card

    this.dataRebuild();
    this.cdRef.detectChanges();

    // this._SignalRService.readUpdatedEvents();
  }

  dataRebuild() {
    if (this._DataHelper.LeagueData == undefined) {
      return;
    }

    const wwsConfig = {
      langCode: this._LocalizationService.LANGCODE,
      lml: this.liveMatchList,
      old_lml: this.oldLiveMatchList,
      cardList: this.cardList,
      oddtype: [0],
      favorable: this._UserHelper.favoriedMatches,
      lfd: this._DataHelper.LeagueData,
      isLive: false,
      liveSortbyTime: false,
    };

    this._DataHelper.webWorkerLiveJob(wwsConfig);

    const promise = this._webWorkerService.run(this._DataHelper.webWorkerLiveJob, wwsConfig).then(result => {
      this.__ResultLiveData = result.dt;

      const Obsobj = of(this.__ResultLiveData);
      this.fullmatch = Obsobj;

      this.isInitialized = true;
      // Fav Data
      this.__ResultLiveFavsData = result.dtFavs;
      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }

  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }

  toggleSportsMenu() {
    this.isOpenSportsMenu = !this.isOpenSportsMenu;
  }

  oddComboChange(oddMarket, index) {
    const newOddMarket: number[] = Array.from(this.oddMarketingB3000Value);
    newOddMarket[index] = oddMarket.OddId;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.oddMarketingB3000Value = newOddMarket;

    const x = this.getFavorableStates(this.preMatchList);
    this.preMatchList = x;
    this.preMatchobservable.next(this.preMatchList);
  }

  oddBoxClick(oddMarket, index) {
    this.combo1SelectedOdd = oddMarket;

    const newOddMarket: number[] = Array.from(this.oddMarketingB3000Value);
    newOddMarket[index] = oddMarket.OddId;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.oddMarketingB3000Value = newOddMarket;

    const x = this.getFavorableStates(this.preMatchList);
    this.preMatchList = x;
    this.preMatchobservable.next(this.preMatchList);
  }

  openFavPreMatches() {
    // this._Router.navigate(['/fav']);
    this.preMatchList = this._UiHelper.favPreMatches;
    this.preMatchobservable.next(this.preMatchList);
    this.dataRebuild();
    // if (this.cdRef != undefined)
    // this.cdRef.detectChanges();
  }

  timeFilterChanged(e) {
    if (this.currentActiveTimeFilter == 0) {
      this.basepreMatchList = this.preMatchList;
    }

    this.currentActiveTimeFilter = e;

    const today = new Date();
    const tomorrow = new Date(today);
    const diffday: number = e;
    // parametre olarak ekleyince çalşmıyor 6 ay sonraya atıyor
    if (e == 1) {
      tomorrow.setDate(tomorrow.getDate() + 1);
    }
    if (e == 7) {
      tomorrow.setDate(tomorrow.getDate() + 7);
    }
    if (e == 15) {
      tomorrow.setDate(tomorrow.getDate() + 15);
    }

    // console.log(e, tomorrow, today.getDate());

    if (e == 0) {
      this.preMatchList = this.basepreMatchList;
    } else {
      this.preMatchList = this.basepreMatchList.filter(m => new Date(m.MatchDate) < tomorrow);
    }
    this.preMatchobservable.next(this.preMatchList);
  }

  add2TournamentFavs() {
    if (this._DataHelper.LeagueData[0] === undefined) {
      return;
    }
    // console.log(this._DataHelper.LeagueData);
    const favitem = {
      tourid: this._DataHelper.LeagueData[0].TournamentId,
      tourname: this._DataHelper.LeagueData[0].TournamentName,
      catid: this._DataHelper.LeagueData[0].CategoryId,
      catname: this._DataHelper.LeagueData[0].CategoryName,
      count: this.preMatchList.length,
    };
    this._UiHelper.favTournamentChanged(favitem);
    this.tournamentFavourited = !this.tournamentFavourited;
  }

  getTournamentStatisticB3000() {
    this._ApiService
      .getTournamentStatisticB3000(this.tournamentSelectionB3000.SportId, this.tournamentSelectionB3000.CategoryId, this.tournamentSelectionB3000.tournamentId)
      .then(x => {
        this.tournamentSelectionB3000.data = x;
        // console.warn("this.tournamentSelectionB3000",this.tournamentSelectionB3000.data)
        this.tournamentSelectionB3000.isTournamentSelection = true;
      });
  }

  getFormTableDataTranslate(data) {
    if (typeof data == 'string') {
      const dataArray = [];

      data
        .split('-')
        .map(item => {
          dataArray.push(item);

          return this.translator.transform(`bet3000_${item}`, null);
        })
        .toString()
        .replace(/,/g, '-');
      return dataArray;
    }
    return '';
  }
  tournamentStatsPage1(whichState: string): void {
    this.tournamentSelection.page1InsideSelection = whichState;
    this.tournamentSelection.page = 1;

    //
    this.tournamentSelectionB3000.page1InsideSelection = whichState;
    this.tournamentSelectionB3000.page = 1;
  }

  tournamentSelectionState(whichState: number): void {
    this.tournamentSelection.page = whichState;
    this.tournamentSelection.page1InsideSelection = 'total';

    ///
    this.tournamentSelectionB3000.page = whichState;
    this.tournamentSelectionB3000.page1InsideSelection = 'total';
  }
  searchInputChange(e) {
    if (e.length >= 3 && !this.flagSearch) {
      this.searchEventSubject.next(e);
    }
  }
  reSendConfirmation() {
    const translator = new TranslatePipe(this._LocalizationService);
    if (this.resendMailButtonState) {
      this.resendMailButtonState = false;
      this._ApiService
        .getResendConfirmationMail()
        .then((x: any) => {
          this._UiHelper.successSnackBar(translator.transform('Resend_Mail_Success_Text', null), '');
        })
        .catch(() => {
          setTimeout(() => (this.resendMailButtonState = true), 3000);
          this._UiHelper.errorSnackBar(translator.transform('help_mail_error', null), '');
        });
    }
  }
  getSearchB3000(e) {
    this._ApiService
      .getSearchB3000(e)
      .then(x => {
        // console.warn('SEARCH', x);
        this._DataHelper.setSearchData(x);
        // this._Router.navigate(['search', e]);
        this.flagSearch = false;
      })
      .catch(err => console.log('err', err));
  }

  showTabsMenu(e?) {
    this._UiHelper.b3000SetAcountMobileState('open', 8, 0);
  }
  goBack() {
    this._location.back();
  }

  showTabsMenuMobile(e?) {
    this._UiHelper.b3000SetAcountMobileState('open', 8, 0);
  }

  // todo deleted , used for wettarena
  goToLink(e: string) {
    try {
      if (e.includes('http')) {
        window.location.href = e;
      } else {
        if (e.charAt(0) != '/') {
          window.location.href = window.location.origin + '/' + e;
        } else {
          window.location.href = window.location.origin + e;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  getResponsiveOddShow(indexOddOrder) {
    switch (indexOddOrder) {
      case 1:
        return this._UiHelper.isResponsiveRules(['s']);
      case 2:
        return this._UiHelper.isResponsiveRules(['xl']);
      case 3:
        return this._UiHelper.isResponsiveRules(['xxl']);
      default:
        return true;
    }
  }
}

export class OddModel {
  constructor(OddId: number) {
    this.OddId = OddId;
  }

  OddId: number;
}

export class OddComboModel {
  constructor(OddId: number, OddName: string, OddNameLong: string, OddTitles: []) {
    this.OddId = OddId;
    this.OddName = OddName;
    this.OddTitles = OddTitles;
    this.OddNameLong = OddNameLong;
  }

  OddId: number;
  OddName: string;
  OddTitles: string[];
  OddNameLong: string;
}
